<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :title="title"
    :destroyOnClose="destroyOnClose"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <CardEdit
      ref="form"
      :source-data="sourceData"
      :schema="BUSINESS_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :defaultColXs="defaultColXs"
      :defaultColSm="defaultColSm"
      :defaultColMd="defaultColMd"
      :defaultColLg="defaultColLg"
      :defaultColXl="defaultColXl"
    ></CardEdit>
  </a-modal>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import BUSINESS_SCHEMA from './schema'
import { addAssurance } from '../api'
import mixin from '../mixin'
import moment from 'moment'
export default {
  components: {
    CardEdit,
  },
  mixins: [mixin],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      BUSINESS_SCHEMA,
      sourceData: {
        companyId: this.$route.params.id,
        id: '',
        type: '',
        code: '',
        insuranceName: '',
        efficientDate: '',
        expireDate: '',
        currencyUnit: '',
        amount: '',
        remark: '',
      },
      defaultColXs: 24,
      defaultColLg: 24,
      defaultColSm: 24,
      defaultColMd: 24,
      defaultColXl: 24,
      formLayout: 'horizontal',
      labelCol: {
        xs: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 16 },
      },
      checkboxList: [],
      tableRow: {},
      filters: [],
      title: '新增',
      destroyOnClose: true,
    }
  },
  created() {
    this.BUSINESS_SCHEMA.type.optionList = []
    for (var key in this.TYPE_NAME_OBJ) {
      this.BUSINESS_SCHEMA.type.optionList.push({
        label: this.TYPE_NAME_OBJ[key],
        value: Number(key),
      })
    }
  },
  methods: {
    // 新增
    add() {
      this.visible = true
      this.$nextTick(() => {
        // 初始化数据
        for (let key in this.sourceData) {
          if (key !== 'companyId') {
            this.sourceData[key] = ''
          }
        }
      })
      this.title = '新增'
    },
    // 维护
    async edit(tableRow) {
      this.title = '编辑'
      this.visible = true
      this.$nextTick(() => {
        this.tableRow = tableRow
        for (let key in this.sourceData) {
          this.sourceData[key] = tableRow[key]
        }
      })
    },
    // 取消
    handleCancel() {
      this.visible = false
    },
    // 校验数据
    async validateForm() {
      var values = await this.$refs.form.handleSubmit()
      console.log(values)
      const passed = !!values
      if (passed) {
        for (let key in this.sourceData) {
          if (values[key] !== undefined) {
            if (key === 'efficientDate' || key === 'expireDate') {
              this.sourceData[key] = moment(values[key]).format('YYYY-MM-DD')
            } else {
              this.sourceData[key] = values[key]
            }
          }
        }
        return this.sourceData
      }
    },
    // 新增｜编辑
    async submitForm() {
      const data = await this.validateForm()
      if (data) {
        data.companyId = this.$route.params.id
        try {
          await addAssurance(data)
          this.visible = false
          this.$emit('getTableList')
        } catch (err) {
          console.log(err)
        }
      }
    },
  },
}
</script>
